import React from "react";

import { cn } from "@/lib/utils";
import { getModelGradientStyle, getModelInitial } from "@/lib/model-thumbnail";

type ModelThumbnailSize = "xs" | "sm" | "md";

const LETTER_SIZE_CLASSES: Record<ModelThumbnailSize, string> = {
  xs: "text-[9px]",
  sm: "text-xs",
  md: "text-base",
};

interface ModelThumbnailFallbackProps {
  title?: string;
  size?: ModelThumbnailSize;
  className?: string;
}

/**
 * Model görseli/thumbnail'ı yoksa gösterilen marka tutarlı fallback:
 * AI Models sayfasındaki (ModelImagePlaceholder) gradient + baş harf tasarımının
 * küçük ikon boyutlarına (picker'lar, listeler) uyarlanmış hali.
 */
export const ModelThumbnailFallback: React.FC<ModelThumbnailFallbackProps> = ({
  title,
  size = "sm",
  className,
}) => (
  <div
    className={cn(
      "relative flex shrink-0 items-center justify-center overflow-hidden rounded",
      className,
    )}
    style={getModelGradientStyle(title)}
  >
    <span
      className={cn(
        "select-none font-black leading-none text-white/40",
        LETTER_SIZE_CLASSES[size],
      )}
    >
      {getModelInitial(title)}
    </span>
  </div>
);
